import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { config, ERoles } from "../../config";
import reduceChildRoutes from "./reduceChildRoutes";
import useAuth from "../../hooks/useAuth";

const SidebarNavList = props => {
    const { pages, depth } = props;
    const router = useLocation();


    const { user } = useAuth();
    // const router = useRouter();
    const currentRoute = router.pathname;

    const roleName = user?.roleName

    let childRoutes = pages.reduce((items, page) => reduceChildRoutes({ items, page, currentRoute, depth }), []);
    if (roleName !== ERoles.SUPER_ADMIN && roleName !== ERoles.RESELLER_ADMIN) {
        const findIndexOfAdminRoutes = childRoutes.findIndex(route => route.key === "Admin");
        if (findIndexOfAdminRoutes !== -1) {
            childRoutes.splice(findIndexOfAdminRoutes, 1);
        }

        // Find master rate route and show for only super admin role
        const findIndexOfMasterRateRoutes = childRoutes.findIndex(route => route.key === "Master Rates");

        if (findIndexOfMasterRateRoutes !== -1) {
            childRoutes.splice(findIndexOfMasterRateRoutes, 1);
        }

        const findIndexOfCustomizedRoutes = childRoutes.findIndex(route => route.key === "Customized Rates");

        if (findIndexOfCustomizedRoutes !== -1) {
            childRoutes.splice(findIndexOfCustomizedRoutes, 1);
        }

        // const findIndexOfAPIMKanagementRoutes = childRoutes.findIndex(route => route.key === "API Keys");
        // if (findIndexOfAPIMKanagementRoutes !== -1) {
        //     childRoutes.splice(findIndexOfAPIMKanagementRoutes, 1);
        // }
    } else {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Applicable Rates");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName !== ERoles.SUPER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Resellers");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName !== ERoles.SUPER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "SuperAdmin");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName !== ERoles.SUPER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Roles");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }
    // const findIndexOfMISRoutes = childRoutes.findIndex(
    //   (route) => route.key === "MIS"
    // );

    // if (findIndexOfMISRoutes !== -1) {
    //   childRoutes.splice(findIndexOfMISRoutes, 1);
    // }

    if (roleName !== ERoles.SUPER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Master Rates");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName === ERoles.ORG_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Clients");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName !== ERoles.SUPER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(
            route => route.key === "Providers" && route.props.href === "/admin/manage-provider",
        );

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName !== ERoles.RESELLER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(
            route => route.key === "Providers" && route.props.href === "/reseller/manage-reseller-provider",
        );

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }
    // if (roleName === ERoles.SUPER_ADMIN) {
    //     const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "RCS Management");


    //     if (findIndexOfApplicableRoutes !== -1) {
    //         childRoutes.splice(findIndexOfApplicableRoutes, 1);
    //     }
    // }
    // if (roleName === ERoles.SUPER_ADMIN) {
    //     const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Reports");
    // }
    //     if (findIndexOfApplicableRoutes !== -1) {
    //         childRoutes.splice(findIndexOfApplicableRoutes, 1);
    //     }
    // }

    if (roleName === ERoles.ORG_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Recharge");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName === ERoles.SUPER_ADMIN && config.REACT_APP_TO_SHOW_MIS_REPORTS_TO_SUPER_ADMIN !== "true") {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Campaign");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName === ERoles.SUPER_ADMIN && config.REACT_APP_TO_SHOW_MIS_REPORTS_TO_SUPER_ADMIN !== "true") {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Bot");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    if (roleName === ERoles.SUPER_ADMIN) {
        const findIndexOfApplicableRoutes = childRoutes.findIndex(route => route.key === "Transactions");

        if (findIndexOfApplicableRoutes !== -1) {
            childRoutes.splice(findIndexOfApplicableRoutes, 1);
        }
    }

    useEffect(() => {

    }, [user?.roleName]);

    return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
